<template>
  <div class="component-content sub-content">
    <div class="title">
      <h2 class="name">资产变更</h2>
    </div>
    <div class="form-content" style="padding:10px;">
      <!-- 资产变更条目 -->
      <p style="padding: 10px 0 0;color: #d93c37;">已选择变更的资产列表</p>
      <el-table class="table-change-list" :data="assetChange.data" style="width: 100%">
        <el-table-column prop="number" label="资产编号" width="150px">
        </el-table-column>
        <el-table-column prop="name" label="资产名称">
        </el-table-column>
        <el-table-column label="资产属性" width="90px">
          <template slot-scope="scope">
            <span v-html="attributeArr[scope.row.attribute]"></span>
          </template>
        </el-table-column>
        <el-table-column prop="spec" label="规格型号">
        </el-table-column>
        <el-table-column prop="manufacturer" label="制造厂商">
        </el-table-column>
        <el-table-column prop="price" label="购置金额" width="90px">
        </el-table-column>
        <el-table-column prop="amount" label="数量" width="60px" align="center">
        </el-table-column>
        <el-table-column prop="purchaseTime" label="购置时间" width="110px">
        </el-table-column>
      </el-table>

      <p style="padding: 10px 0 10px;color: #d93c37;">变更内容</p>
      <div style="border:1px #ccc solid;overflow:hidden;">
        <el-col :span="23">
          <div v-if="this.assetChange.data.length > 1"
            style="background:#d93c37;color:#fff;margin:20px 0 0 20px;padding:10px 15px;border-radius:5px;">
            提示：同时编辑多条记录时请只填写需要统一修改的内容</div>
          <el-form ref="form" :model="form" label-width="110px" class="form">
            <asset-form ref="create" :userData="userData" :changeType="assetChange.type" :formByFather="form">
            </asset-form>
          </el-form>
        </el-col>
      </div>

      <div class="form-btn-room" style="margin-top:15px;">
        <el-button :loading="formLoading" @click="createAsset()" class="form-btn" type="success">{{formBtnText}}
        </el-button>
        <el-button @click="$router.back()" type="info" plain>取消</el-button>
      </div>
    </div>
  </div>
</template>

<script>
  import {
    mapState
  } from "vuex";

  // import Create1 from '../form/create1'
  import AssetForm from './components/assetForm'
  export default {
    components: {
      AssetForm,
    },
    computed: {
      ...mapState({
        assetChange: state => state.asset.assetChange,
        organization: state => state.main.organization,
        userData: state => state.main.userData,
      })
    },
    data() {
      return {
        // 组织架构
        organizationListData: [],
        // 是否可以切换公司
        noSelectOrganization: true,

        attributeArr: ['自制', '采购', '租赁', '出租', '其他'],
        form: {
          depId: '',
          number: '',
          name: '',
          amount: 1,
          attribute: '',
          bxTime: '',
          ccTime: '',
          classifyId: '',
          manufacturer: '',
          price: '',
          purchaseTime: '',
          remark: '',
          spec: '',
          storageTime: '',
          supplierId: '',
          usePlace: '',
          userId: '',
          ver: '',
          certificateNum: '',

          // 残值、折旧年限
          cz: '',
          zjnx: '',
          
          // 0715
          rzTime: '',
          zrUserId: '',
          cwUserId: '',

          // 0920
          zjhm: '',
          mj: '',
          attachments: '',

          status: '',
        },

        // loading状态
        formLoading: false,
        formBtnText: '确认提交'
      }
    },
    created() {
      this.form.assetIds = this.assetChange.data.map(item => item.id).join(",")
      // 只变更单条的话
      // console.log(this.assetChange.type)
      if (this.assetChange.type == 1) {
        // console.log(this.assetChange.data[0])
        this.form.assetNumber = this.assetChange.data[0].number
        // this.getAssetDetail()
      }
    },
    mounted() {
      this.organizationListData = this.organization[0].childDepts
      // this.form.depId = this.userData.secDepIds.split(",")[0] / 1
      if (this.userData.secDepIds.split(",")[0] == "7") {
        this.noSelectOrganization = false
      }
    },
    methods: {
      // 资产变更提交
      createAsset() {
        this.form = this.$refs.create.getFromData()
        this.form.assetIds = this.form.assetIds.join(",")
        this.form.panType = this.form.panType == true ? '1' : ''

        ajax.post('/asset/change/add', this.form, (res) => {
          this.$message.success("资产信息变更成功")
          this.$router.push("/Asset/ChangeList")
        })
      },
    },
    watch: {

    },
  };
</script>


// WEBPACK FOOTER //
// src/page/asset/edit.vue